import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { featuredVideos } from '@/mocks/homeData';

export default function FeaturedVideos() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {t('featured.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('featured.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group rounded-xl overflow-hidden bg-background-50 hover:scale-[1.02] transition-all"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                    video.isVip
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {video.isVip ? t('featured.vip') : t('featured.free')}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs">
                  {video.duration}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 opacity-0 group-hover:opacity-100 transition-all transform group-hover:scale-100 scale-75">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-1">{video.description}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-accent-500 text-xs font-medium">
                      <i className="ri-star-fill mr-0.5"></i>{video.rating}
                    </span>
                    <span className="text-xs text-foreground-400">{video.views}次观看</span>
                  </div>
                  <span className="text-xs text-foreground-400">{video.category}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            {t('category.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}